module.exports = __webpack_public_path__ + "img/logo.fefe8d8b.png";